import React, { useState, useEffect } from "react";
import { Row, Col, Skeleton, Typography, Button } from "antd";
import ProspectList from "./ProspectList";
import BreadcrumbComponent from "./Breadcrumb";
import ProspectDetail from "./ProspectDetail";
import Directus from "api/index";
import axios from "axios";
import Empty from "./empty.svg";
import { useHistory } from "react-router-dom";
import API_KEY from "api/recommendations";


const { Title } = Typography;
export default function Prospects() {
  const [active, setActive] = useState([]);
  const [loadMore, setLoadMore] = useState(false);
  const [buyerData, setBuyerData] = useState(null);
  const [prospects, setProspects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingBuyer, setLoadingBuyer] = useState(false);
  const [contactData, setContactData] = useState(null)
  const history = useHistory();

  const fetchBuyerData = (id) => {
    setLoadingBuyer(true);
    axios
      .get(`https://suggest.sourcerer.tech/buyer_data?id=${id}`)
      .then((res) => {
        setLoadingBuyer(false);
        setBuyerData(res.data);
      })
      .catch((err) => {
        setLoadingBuyer(false);
        console.log(err);
      });
  };

  const fetchProspects = () => {
    setLoading(true);
    Directus.URL.get(Directus.path.prospects, {
      params: {
        fields: "country,id,name,importer_id",
      },
    })
      .then((res) => {
        setProspects(res?.data?.data);
        setLoading(false);
        setActive(res?.data?.data?.[0]?.id);
        fetchBuyerData(res?.data?.data?.[0]?.importer_id);
        fetchContactDetails(res?.data?.data?.[0]?.importer_id);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProspects();
  }, []);

  const handleProspectChange = (id,importer_id) => {
    setActive(id);
    fetchBuyerData(importer_id);
    fetchContactDetails(importer_id);
  };

  const fetchContactDetails = (id) => {
    setLoading(true);
    API_KEY.URL.post(`${API_KEY.path.contact}?buyer_id=${id}&user_id=${localStorage.getItem("email")}`, {
  }).then((res) => {
    setLoading(false);
    setContactData(res.data)
  })
  .catch((err) => {
    console.log("error",err);
    setLoading(false);
  })


}

  return (
    <>
      <BreadcrumbComponent />

      {prospects.length > 0 ? (
        <>
          <Row style={{ marginTop: "2em" }}>
            <Col span={6} style={{ background: "#F5F5F5", padding: 8 }}>
              <Row justify="space-between">
                {loading ? (
                  <Skeleton active />
                ) : (
                  <ProspectList
                    active={active}
                    handleProspectChange={handleProspectChange}
                    data={prospects}
                  />
                )}
              </Row>
            </Col>
            <Col span={16} offset={1}>
              <ProspectDetail
                data={
                  prospects.filter((item) => item?.id === parseInt(active))?.[0]
                }
                loadMore={loadMore}
                setLoadMore={setLoadMore}
                loadingBuyer={loadingBuyer}
                buyerData={buyerData}
                fetchProspects={fetchProspects}
                contactData={contactData}
              />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row style={{ marginTop: "1em" }}>
            <Title level={4}>Prospects (0)</Title>
          </Row>
          <Row
            justify="center"
            style={{
              border: "1px solid #E6E7E7",
              marginTop: "2em",
              padding: "1.5em",
            }}
          >
            <Col span={24}>
              <Row justify="center">
                <img src={Empty} alt="Empty" />
              </Row>
              <Row justify="center">
                <Title level={5}>You have not added any prospects</Title>
              </Row>

              <Row style={{ marginTop: "1.5em" }} justify="center">
                <Button
                  onClick={() => history.push("/buyer-list")}
                  size="large"
                  style={{ background: "#363E3D", color: "white", border: 0 }}
                >
                  View all buyers
                </Button>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
